import { render, staticRenderFns } from "./service_details.vue?vue&type=template&id=54f3df4e&scoped=true&"
import script from "./service_details.vue?vue&type=script&lang=js&"
export * from "./service_details.vue?vue&type=script&lang=js&"
import style0 from "./service_details.vue?vue&type=style&index=0&id=54f3df4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3df4e",
  null
  
)

export default component.exports